import { render, staticRenderFns } from "./RegisterHospitalSelectDialog.vue?vue&type=template&id=1294dae1&scoped=true"
import script from "./RegisterHospitalSelectDialog.vue?vue&type=script&lang=js"
export * from "./RegisterHospitalSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1294dae1",
  null
  
)

export default component.exports